<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="outstockRawMaterialCheck commonListStyles">
            <HeaderNav
                header-title="原材料出库审核"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">出库单号：{{ item.outstock_number }}</span>
                                    </h4>
                                    <div class="itemContent" @click="openOutboundForm(item)">
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_34@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>库位名称：{{ item.grid_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>出库总量：{{ item.volume_outstock }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>出库时间：{{ item.outstock_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>状态：{{ item.status_str }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns" v-if="item.status === 1">
                                        <button @click="affirmFun(item)">
                                            确认出库
                                        </button>
                                        <button @click="backFun(item)">
                                            退回
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <div class="add_btn" @click="openWarehouseReceipt(null, 'add')" v-if="tableCode === 'instock_return_apply'">
                +
            </div>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'outstock-raw-material-check',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'outstock-raw-material-check');
        }
        next();
    },
    data() {
        return {
            tableCode: 'outstock_raw_material_check',
            listType: 1,
            StatusData: [
                {
                    name: '待提交',
                    value: 0,
                    bg_color: '#F85B5B',
                },
                {
                    name: '待审核',
                    value: 1,
                    bg_color: '#F85B5B',
                },
                {
                    name: '待入库',
                    value: 2,
                    bg_color: '#F85B5B',
                },
                {
                    name: '已入库',
                    value: 3,
                    bg_color: '#F8985B',
                },
                {
                    name: '已作废',
                    value: 4,
                    bg_color: '#F8985B',
                },
            ],
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        this.onRefresh();
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        openOutboundForm(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'outstockRawMaterialCheckForm', params: { data: item } });
        },
        async affirmFun(item) {
            this.$dialog.confirm({
                message: `确认出库单 \n【${item.outstock_number}】出库？`,
            }).then(async () => {
                const res = await this.affirmData(item.id);
                if (res) {
                    this.$toast('出库成功！');
                }
                this.onRefresh();
            });
        },
        async backFun(item) {
            this.$dialog.confirm({
                message: `确认要退回出库单 \n【${item.outstock_number}】？`,
            }).then(async () => {
                const res = await this.backData(item.id);
                if (res) {
                    this.$toast('退回成功！');
                }
                this.onRefresh();
            }).catch(() => {});
        },
        affirmData(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/outstock/${id}`, { defEx: true });
        },
        backData(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/back/${id}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.purchaseInventory
    position relative
    .add_btn
        position absolute
        right 14rpx
        bottom 14rpx
        width 42rpx
        height 42rpx
        background #EB6348
        color #fff
        border-radius: 50%
        font-size 32rpx
        text-align: center
        line-height: 34rpx
    section
        .van-pull-refresh
            height: calc(100% - 42rpx) !important
        .engineeringInfo
            position relative
            .btn
                position absolute
                top 0
                right 0
                color #fff !important
                font-size 12rpx !important
                background: #f86565;
                padding 2rpx 5rpx
                border-radius: 0 8rpx
                font-weight: 500 !important;
                height: auto !important;
</style>
